import type { UserStore } from "../../../stores/user";
import type { AddressesStore } from "../../../stores/addresses";

const userStore: Partial<UserStore> = {
  user: {
    first_name: "",
    last_name: "",
    email: "",
    phone: ""
  },
  hasLoaded: true
};

const addressesStore: Partial<AddressesStore> = {
  addresses: [],
  mode: "create",
  hasLoaded: true
};

export default {
  userStore,
  addressesStore
};
